import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';
import { ModalBaseComponent } from 'src/app/shared/modals/modal-base/modal-base.component';

@Component({
    selector: 'app-editcontrolledareatrafficlight',
    templateUrl: './editcontrolledareatrafficlight.component.html',
    styleUrls: ['./editcontrolledareatrafficlight.component.scss'],
    standalone: false
})
export class EditcontrolledareatrafficlightComponent extends ModalBaseComponent<any, null> {
  Form !: UntypedFormGroup;
  constructor() {
    super();
  }
}
